import Vue from 'vue';
import Vuex from 'vuex';

import app from './modules/app';
import signInQuery from './modules/signInQuery';
import getters from './getters';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    signInQuery
  },
  state: {},
  mutations: {},
  actions: {},
  getters
});



// WEBPACK FOOTER //
// ./src/store/index.js